import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from '../services/local-storage.service';
import { UserContextService } from '../services/user-context.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private userContextService: UserContextService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {          
        //let token = this.localStorageService.getItem('token');
        // let user = document.cookie;
        let user = this.userContextService.user$.getValue();
        if (user != null) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url and return false
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
// handle when logined but user still access login page
@Injectable()
export class AuthGuardLogin implements CanActivate {

    constructor(private router: Router, private userContextService: UserContextService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {                
        let user = document.cookie;
        if (user != null) {
            // logged in so return true
            return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
